<template>
  <b-form id="edit-max-participant-modal" @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>{{ $t("numOfParticipants") }} <span class="text-danger">*</span></template>
      <b-form-input type="number" v-model="numberofParticipants" required></b-form-input>
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{
        $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("save") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped></style>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import * as meetingService from "@/service/meetingService";
import * as validationUtils from "@/service/validationUtils";
import * as contactService from "@/service/contactService";
import * as util from "@/service/util";

@Component
export default class EditMaxParticipantModal extends BaseComponent {

  @Prop({ required: true }) modalId: string;
  @Prop({ required: true }) meetingId: number;

  @Prop({ default: 0 }) maxParticipants: number;

  @Emit("submitted") __submitted() { }


  numberofParticipants: number = 0;


  // Lắng nghe thay đổi khi bấm vào các meeting khác nhau
  @Watch('maxParticipants', { immediate: true })
  onMaxParticipantsChange(val: number) {
    this.numberofParticipants = val;
  }

  typeaheadOptions = [];

  formErrorMsg = "";
  isSubmitting = false;



  mounted() {

  }




  onClickCancel() {
    this.$bvModal.hide(this.modalId);
  }


  async submitForm() {
    this.formErrorMsg = "";
    console.log("MeetingId", this.meetingId);
    // this.numberofParticipants = this.name.trim();

    // if (!validationUtils.isEmail(this.email)) {
    //   this.formErrorMsg = this.$t("invalidEmail").toString();
    //   return;
    // }

    // const data = {
    //   meetingId: this.meetingId,
    //   name: this.name,
    //   email: this.email.toLowerCase(),
    //   phone: this.phone,
    //   role: "PARTICIPANT",
    //   assignedBy: this.userId,
    // };

    try {
      this.isSubmitting = true;
      await meetingService.editMaxParticipants(this.meetingId, this.numberofParticipants);

      this.__submitted();
      this.toastSuccessDelay(this.$t("addMaxMeetingParticipantSuccess").toString());
      this.$bvModal.hide(this.modalId);

    } catch (e) {
      this.toastError(e);

    } finally {
      this.isSubmitting = false;
    }
  }

}
</script>
